export default __webpack_public_path__ + "static/media/puzzleClue6.a8958cc7.png";